import { combineReducers } from 'redux';
import { authReducer } from './Auth.reducer';
import TestReducer from "../../../store/test/reducer";

export default combineReducers({
    auth: authReducer,
})